import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse("1234567890123456");
const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

export function encryption(value) {
  return CryptoJS.AES.encrypt(value, key, { iv }).toString();
}

export function decryption(value) {
  const bytes = CryptoJS.AES.decrypt(value, key, { iv });
  return bytes.toString(CryptoJS.enc.Utf8);
}